import React from "react";
import Button from "../../components/Button";
import SimpleModal from "./SimpleModal";
import { Title, SubTitle, SubLabel } from "./styles";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  handleNextModal: () => void;
}

const InstructionAppModal: React.FC<Props> = ({
  isOpen,
  toggle,
  handleNextModal,
}) => {
  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={toggle}
      title=""
      size="md"
    >
      <div style={{ padding: "24px" }} className="modal-content-responsive">
        <Title>Habilitar autenticación de dos factores</Title>
        <SubTitle>Instrucciones de configuración</SubTitle>

        <div style={{ marginTop: "12px" }}>
          <h5 style={{ fontSize: "15px", fontWeight: "600", marginBottom: "8px" }}>
            Paso 1: Abre tu aplicación de autenticación
          </h5>
          <SubLabel style={{ marginBottom: "8px", fontSize: "14px", lineHeight: "1.4" }}>
            Abre la app de autenticación en tu teléfono móvil.
          </SubLabel>

          <h5 style={{ fontSize: "15px", fontWeight: "600", marginBottom: "8px", marginTop: "12px" }}>
            Paso 2: Agrega una nueva cuenta
          </h5>
          <SubLabel style={{ marginBottom: "8px", fontSize: "14px", lineHeight: "1.4" }}>
            Busca la opción para agregar cuenta o escanear QR.
          </SubLabel>

          <h5 style={{ fontSize: "15px", fontWeight: "600", marginBottom: "8px", marginTop: "12px" }}>
            Paso 3: Escanea el código QR
          </h5>
          <SubLabel style={{ marginBottom: "0", fontSize: "14px", lineHeight: "1.4" }}>
            En la siguiente pantalla, escanea el código QR con tu app.
          </SubLabel>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "12px",
          padding: "0 24px 24px",
        }}
        className="modal-footer-responsive"
      >
        <Button
          type="button"
          options={{ skin: "secondary", size: "md", type: "filled" }}
          onClick={toggle}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={handleNextModal}
        >
          Continuar
        </Button>
      </div>

            <style>{`
        @media (max-width: 768px) {
          .modal-content-responsive {
            padding: 16px !important;
          }
          .modal-footer-responsive {
            flex-direction: column !important;
            padding: 0 16px 16px !important;
          }
          .modal-footer-responsive button {
            width: 100%;
          }
        }
      `}</style>
    </SimpleModal>
  );
};

export default InstructionAppModal;
